module.exports = __webpack_public_path__ + "img/04.ce4f027f.png";